<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Currencies</h1>
    <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset">
            <label class="block text-gray-700">Trashed:</label>
            <select v-model="form.trashed" class="mt-1 w-full form-select rounded">
                <option :value="null" />
                <option value="with">With Trashed</option>
                <option value="only">Only Trashed</option>
            </select>

            <label class="block text-gray-700">Type:</label>
            <select v-model="form.type" class="mt-1 w-full form-select rounded">
                <option :value="null" />
                <option value="coin">Coin</option>
                <option value="fiat">Fiat</option>
            </select>
        </search-filter>
        <nav-button-link :href="route('admin.currencies.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new currency</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Name</th>
                <th class="px-6 pt-6 pb-4">Symbol</th>
                <th class="px-6 pt-6 pb-4">Type</th>
                <th class="px-6 pt-6 pb-4">Status</th>
            </tr>
            <tr v-for="currency in currencies.data" :key="currency.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.currencies.edit', currency.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ currency.name }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <inertia-link :href="route('admin.currencies.edit', currency.id)" class="px-6 py-4 flex items-center">
                        {{ currency.symbol }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        <badge v-if="currency.type == 'coin'" class="mr-2" type="gray">
                            {{ 'coin' }}
                        </badge>
                        <badge v-if="currency.type == 'fiat'" class="mr-2" type="green">
                            {{ 'fiat' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">

                        <badge class="mr-2" v-if="currency.deleted_at" type="red">
                            {{ 'Trashed' }}
                        </badge>

                        <badge class="mr-2" v-if="!currency.deleted_at" :type="currency.status ? 'green' : 'gray'">
                            {{ currency.status ? 'Active' : 'Hidden' }}
                        </badge>

                        <badge class="mr-2" v-if="!currency.deleted_at && currency.status" :type="currency.deposit_status ? 'green' : 'red'">
                            {{ currency.deposit_status ? 'Depositable' : 'Deposits Suspended' }}
                        </badge>

                        <badge v-if="!currency.deleted_at && currency.status" :type="currency.withdraw_status ? 'green' : 'red'">
                            {{ currency.withdraw_status ? 'Withdrawable' : 'Withdrawals Suspended' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="currencies.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No currencies found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="currencies.links" />
</app-layout>
